import AuthHeader from '../UI/authHeader/auth-header'
import SignupFooter from './signup-footer/signup-footer'
import SignUpCard from './signUpCard'

const SignUpUI = () => {
  return (
    <>
    <AuthHeader />
    <SignUpCard />
    <SignupFooter />
    </>
  )
}

export default SignUpUI
